var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.243896,
    y: 0.558594,
    width: 64.316,
    height: 64.316,
    rx: 14.6173,
    fill: "#FFB447"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.054 37.8328C17.054 41.6001 20.108 44.6542 23.8753 44.6542H39.2235C43.9327 44.6542 47.7502 40.8366 47.7502 36.1274C47.7502 31.4182 43.9327 27.6007 39.2235 27.6007C39.1666 27.6007 39.1099 27.6012 39.0532 27.6024C38.2639 23.7095 34.8225 20.7793 30.6967 20.7793C25.9875 20.7793 22.17 24.5968 22.17 29.306C22.17 29.9487 22.2411 30.5747 22.3758 31.1767C19.3299 31.86 17.054 34.5806 17.054 37.8328Z",
    fill: "#060606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOn);
export default __webpack_public_path__ + "static/media/cloud-on.c3e252129254fef233b8b319749822fa.svg";
export { ForwardRef as ReactComponent };